<template>
  <v-main>
    <!-- auth sentinel; does its query-string check / redirect / etc -->
    <!-- auth Has been disabled for this project. -->
    <auth />

    <!-- FULLSCREEN MEDAL PICKER DIALOG -->
    <v-dialog
      v-model="medal_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card dark class="medal-dialog-card">
        <v-toolbar dark color="cmpbk" flat>
          <v-btn icon @click="close_medal_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title class="text-center flex-grow-1">
            RPD Award Nomination
          </v-toolbar-title>

          <div style="width: 48px;"></div>
        </v-toolbar>


        <v-card-text class="pt-6">
          <div class="white--text">
            <div class="text-h5 font-weight-bold mb-4">
              Thank you for taking the time to create this award nomination.
            </div>
            <div class="mb-6 ">
              Since its creation in 1903, the Reno Police Department has had the honor of being served by many brave individuals.
              It is incumbent upon us to recognize those whose selfless acts are truly exceptional.
            </div>
          </div>

          <div class="text-h6 font-weight-bold mb-3 white--text">
            What medal are you submitting a nomination for?
          </div>

          <v-list dark class="medal-list">
            <v-list-item
              v-for="m in medals"
              :key="m.name"
              class="medal-item"
              link
              @click="select_medal(m.name)"
            >
              <v-list-item-content>
                <div class="medal-title">
                  {{ m.name }}
                </div>
                <div class="medal-desc" v-html="m.desc">
               
                </div>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon v-if="nom.selectedMedal === m.name">mdi-check-circle</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MAIN FORM -->
    <v-container fluid class="py-4">
      <v-row justify="center" no-gutters>
        <v-col cols="12" class="px-2" style="max-width: 768px">
          <v-card dark>
            <v-card-text color="cmpbk" dark>
              <v-btn color="yellow" dark class="black--text mb-4" @click= "medal_dialog = true" >Back to Medal Definitions </v-btn>
              <v-form
                lazy-validation
                ref="medalForm"
                v-model="formValid"
                dark
                class="white--text"
              >
                <p>What medal are you submitting a nomination for?</p>

        
                <v-text-field
                  v-model="nom.selectedMedal"
                  label="Click to select a medal"
                  outlined
                  dense
                  readonly
                  clearable
                  hide-details
                  :rules="[rules.required]"
                  @click="medal_dialog = true"
                  @click:append="medal_dialog = true"
                  append-icon="mdi-chevron-right"
                />
               <label class="mt-6 d-block">Medal Description</label>

                <div v-if="selectedMedalObj" class="medal-selected-desc" v-html="selectedMedalObj.desc"></div>

              
                  <p>Which employee(s) are you nominating? (Name)</p>

                    <v-combobox
                      v-model="nom.nominatedEmployees"
                      :delimiters="[';', ',']"
                      class="nominee-combobox"
                      outlined
                      dense
                      multiple
                      chips
                      deletable-chips
                      clearable
                      :rules="nomineeRules"
                      hint="Add up to 10 names. Press Enter or Comma after each name."
                      persistent-hint
                      hide-details="auto"
                      @blur="nomineeTouched = true"
                    />

                <p>Event case or call number (if applicable)</p>
                <v-text-field
                  v-model="nom.eventCaseOrCallNumber"
                  label="Enter your answer"
                  outlined
                  dense
                  clearable
                  maxlength="12"
                />

                <p>
                  Do you have supporting documentation to upload? (i.e.
                  nomination memorandum, emails, letters, statements from
                  medical personnel etc.)
                </p>

                <v-select
                  v-model="nom.hasSupportingDocumentation"
                  :items="['Yes', 'No']"
                  label="Select one"
                  outlined
                  dense
                  clearable
                  attach
                  :rules="[rules.required]"
                />

                <p v-if="nom.hasSupportingDocumentation === 'Yes'">
                  Upload Supporting Documentation (you can add multiple files)
                </p>

                    <v-file-input
                      ref="supportingFiles"
                      v-if="nom.hasSupportingDocumentation === 'Yes'"
                      v-model="supportingFilesIncoming"
                      label="Upload files"
                      outlined
                      dense
                      multiple
                      truncate-length="50"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      :rules="[filesRequiredRule]"
                      @change="onSupportingFilesChange"
                    />

                  <div v-if="nom.hasSupportingDocumentation === 'Yes'" class="file-type-hint mt-1 mb-3">
                    File types supported: .pdf, .doc, .docx, .jpg, .jpeg, .png — This app does not support the upload of body worn camera videos or any other CJIS protected material.
                  </div>

                  <!-- Selected files preview -->
                  <div
                    v-if="nom.hasSupportingDocumentation === 'Yes' &&
                          Array.isArray(nom.supportingDocumentationFiles) &&
                          nom.supportingDocumentationFiles.length"
                    class="mt-2"
                  >
                    <div class="subtitle-2 mb-1">Selected files (ready to upload)</div>

                    <v-chip-group column>
                      <v-chip
                        v-for="(f, i) in nom.supportingDocumentationFiles"
                        :key="`${f.name}-${f.size}-${i}`"
                        class="ma-1"
                        close
                        @click:close="removeSupportingFile(i)"
                      >
                        {{ f.name }} ({{ prettyBytes(f.size) }})
                      </v-chip>
                    </v-chip-group>
                  </div>

                <p class="mt-3">
                  Nomination Narrative – articulate why the employee is
                  deserving of this award (what facts, circumstances, statements
                  or evidence support this nomination)?
                </p>

                <v-textarea
                  v-model="nom.nominationNarrative"
                  label="Enter your answer"
                  outlined
                  dense
                  auto-grow
                  rows="4"
                  clearable
                  :rules="[rules.required]"
                  maxlength="8000"
                  counter
                />

                <p>Person submitting nomination (email)</p>
                <v-text-field
                  v-model="nom.submittedByEmail"
                  label="Enter your email"
                  outlined
                  dense
                  clearable
                  :rules="[rules.required, rules.email]"
                />
              </v-form>

              <v-card-actions>
                <v-btn
                  dark
                  color="cmpbk"
                  @click="save_awardnom"
                  :disabled="supportingFileRequiredMissing"
                >
                  Submit Nomination
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>


<style lang="scss" scoped>
@import "../scss/site.scss";


/* Make the field tall enough for multiple lines */
.nominee-combobox :deep(.v-input__control .v-input__slot) {
  /* Let it grow naturally; don't force a tiny min-height */
  min-height: 56px !important;
  padding-top: 6px !important;     /* keeps first chip close to outline */
  padding-bottom: 6px !important;
}

/* Allow the selections area to wrap and START at the top */
.nominee-combobox :deep(.v-select__selections) {
  align-items: flex-start !important;
  flex-wrap: wrap !important;
  padding-top: 0 !important;       /* remove extra gap above first row */
  padding-bottom: 0 !important;
  line-height: normal !important;
}

/* Give chips vertical breathing room so wrapped rows don't overlap */
.nominee-combobox :deep(.v-select__selections .v-chip) {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.file-type-hint {
  font-size: 0.78rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.7);
}

.medal-selected-desc {
  margin-top: 10px;
  padding: 12px;
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 10px;
  line-height: 1.5;
  opacity: 0.95;
  margin-bottom: 20px;
}

.medal-dialog-card {
  height: 100vh;
}

.medal-item {
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 10px;
  margin-bottom: 12px;
  transition: background-color 120ms ease, border-color 120ms ease, transform 120ms ease;
}

.medal-item:hover {
  border-color: rgba(255, 255, 255, 0.85);
  background-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
}

.medal-title {
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 6px;
}

.medal-desc {
  opacity: 0.9;
  line-height: 1.5;
}


/* your existing responsive bits */
@media (max-width: 767px) {
  .v-form p {
    white-space: normal !important;
    overflow-wrap: anywhere !important;
    word-break: break-word !important;
    max-width: 100% !important;
  }

  .v-card,
  .v-card__text {
    overflow-x: hidden !important;
  }
}
</style>



<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";

export default {
  name: "Home",
  components: { auth },
  mixins: [bus_common],
 
  data() {
    return {
      submitAttempted:false,
      nomineeTouched:false,
      supportingFilesIncoming: [],
      medal_dialog: true,
      formValid: false,

      nom: {
        selectedMedal: "",
        nominatedEmployees: [],  // <-- NEW (array)
        eventCaseOrCallNumber: "",
        hasSupportingDocumentation: "",
        supportingDocumentationFiles: [],
        nominationNarrative: "",
        submittedByEmail: "",
      },

      nom_new: {
        selectedMedal: "",
        nominatedEmployees: [],  // <-- NEW (array)
        eventCaseOrCallNumber: "",
        hasSupportingDocumentation: "",
        supportingDocumentationFiles: [],
        nominationNarrative: "",
        submittedByEmail: "",
      },

      // Use this list to drive BOTH the dialog and any other UI
medals: [
  {
    name: "The Police Medal of Honor",
    desc:
      "The department’s highest level of recognition. This medal may be awarded for an act that involves extreme risk to the employee’s life, voluntarily taken with knowledge of the imminent threat of personal safety, who distinguishes themselves conspicuously by gallantry and intrepidity above and beyond the call of duty. There must be no margin of doubt or possibility of error in awarding this honor. To justify this award, the act must be clearly rendered conspicuous above their comrades by an act so outstanding that it clearly distinguishes their gallantry beyond the call of duty from lesser forms of bravery; and it must be the type of deed which if not done, would not subject the individual to any justified criticism.",
  },
  {
    name: "The Police Medal of Valor",
    desc:
      "The department’s second highest level of recognition. This medal may be awarded for an act that involves a significant risk to life of an employee, with a demonstration of courage that goes beyond behavior normally required of individuals in the law enforcement profession, and sets the individual apart from his or her fellow officers. Although the employee displayed extraordinary heroism, the act does not justify the Medal of Honor.",
  },
  {
    name: "The Police Medal of Courage",
    desc:
      "The department’s third highest level of recognition. This medal may be awarded to an employee for facing heightened risk to life or severe injury, who also demonstrates courage that is keeping with the law enforcement profession. The incident the employee faced must be abnormal for them to face in their day-to-day operations. Although the employee displayed heroism, the act does not justify the Medal of Valor.",
  },
  {
    name: "The Police Medal of Meritorious Service",
    desc:
      `This medal may be awarded to an employee for meritorious service in a duty of great responsibility, 
      involving operational risk to the employee. It may also be awarded to an employee for an act which results in 
      the saving of a life or attempted saving of a life, during which extraordinary efforts were used and personal risk to the employee was involved.`,
  },
  {
    name: "The Police Cross Medal",
    desc:
      `This medal is awarded posthumously when an employee has lost his or her life in 
      the performance of his or her duties under honorable circumstances.`,
  },
  {
    name: "The Purple Heart Medal",
    desc:
      `This medal may be awarded to an employee who is wounded in a significant nature during the scope of their employment. 
      This could be from an altercation with a suspect or from an encounter with an individual whose use of a dangerous or deadly weapon
       has inflicted said wounds.`,
  },
  {
    name: "The Lifesaving Medal",
    desc:
      "This medal may be awarded to an employee who saves someone’s life under circumstances in which the employee was not in danger while doing so.",
  },
  {
    name: "The Distinguished Service Medal",
    desc:
      `<p>This medal may be awarded to recognize an employee’s positive contributions to the department or to recognize an employee’s accomplishments over the course of their career.</p>

<p>Employees can qualify under one of three categories:</p>

<ol style="margin-left: 1.25rem; padding-left: 1.25rem;">
  <li>After serving a minimum of twenty (20) continuous years of exemplary service with the Reno Police Department;</li>
  <li>After serving a minimum ten (10) continuous years of exemplary service with the Reno Police Department and separates from the department under honorable circumstances;</li>
  <li>Or to represent a medal presented by another governmental agency for action taken in law enforcement capacity while employed by RPD, but that does not fall into the criteria of a departmental medal; and does not arise from the same event that another Reno Police medal was awarded.</li>
</ol>

<p>In considering whether to recommend a qualified employee for this medal, the Awards and Commendations Board may also consider:</p>

<ol style="margin-left: 1.25rem; padding-left: 1.25rem;">
  <li>Whether the nominee was be deemed by their peer(s) and supervisor(s) to demonstrate departmental values and possess an outstanding work ethic.</li>
  <li>Whether the nominee possessed a professional demeanor and outstanding job knowledge.</li>
  <li>The disciplinary record of the nominee.</li>
</ol>`
,
  },
  {
    name: "The Chief’s Commendation Medal",
    desc:
      `<p>This medal may be awarded by the Chief/designee without the recommendation of the Board.</p>

<p>This medal may be awarded to citizens, in addition to employees.</p>

<ol style="margin-left: 1.25rem; padding-left: 1.25rem;">
  <li><strong>Employee:</strong> This is medal may be awarded to an employee, regardless of rank, for exceptional meritorious performance while conducting an administrative or operational assignment.</li>
</ol>`
,
  },
    {
    name: "Chief’s Certificate of Commendation",
    desc:
      `This certificate may be awarded to an employee or citizens under any of the following circumstances:
      <ol>
      <li>An employee of any rank for superior performance of duties or exemplary behavior that are either administrative or operational in nature;</li>
      <li>An employee of another agency that qualifies under any of the above mentioned conditions, if earned while aiding, assisting, or working with any employee of the Reno Police Department;<li.
      <li>Any distinct work group of employees when the actions of the group as a whole meet the qualifications; or</li>
      <li>Citizens whose actions exemplify excellence in performance of civic responsibilities, showing unselfish devotion to their fellow humans and community, and/or bringing honor to themselves and recognition to the City through their actions.</li>`
,
  },
  {
    name: "Al Del Vecchio Award for Policing Excellence",
    desc:
      `<p>The Al Del Vecchio Award for Policing Excellence is a prestigious regional honor that recognizes patrol officers and deputies who demonstrate
the highest standards of service within law enforcement.</p>

<p>This award celebrates those who show exceptional dedication, professionalism,
and commitment to upholding the core values of law enforcement.</p>

<p>Candidates for the Del Vecchio Award must meet the following criteria:</p>

<ol type="a" style="margin-left: 1.25rem; padding-left: 1.25rem;">
  <li><strong>Tenure:</strong> The candidate must have at least seven (7) years of continuous exemplary service with their agency, including a minimum of five (5) years in patrol duties, and must currently be assigned to patrol as an officer or deputy. The candidate must be in patrol and the time of nomination and the time of the award ceremony.</li>

  <li><strong>Leadership and Community Engagement:</strong> The candidate must demonstrate leadership through a strong work ethic, professional demeanor, competence, and mentorship of fellow officers. They should have a commitment to building and maintaining positive community partnerships and embody the core values of law enforcement. Ideal candidates will be passionate about serving their community and working to strengthen cooperation and trust between law enforcement and the community.</li>

  <li><strong>Core Values:</strong> Officer Al Del Vecchio was a tenacious and initiative driven officer who embodied the qualities of guardianship and warriorship. Candidates should consistently display traits such as courage, service, integrity, compassion, wisdom, charity, patience, restraint, dedication, empathy, virtue, victim centric policing, and selfless service to the community.</li>

  <li><strong>Performance and Conduct:</strong> A review of the candidate’s performance evaluations and disciplinary record will be conducted. Nominees with serious or sustained policy violations within the past five years will not be considered.</li>

  <li><strong>Professional Standards:</strong> Candidates must be recognized by their peers and supervisors for outstanding work ethic, professionalism, integrity, and a comprehensive understanding of law enforcement.</li>

  <li><strong>Combined Award Ceremony:</strong> The award will be presented during the NNLEA Academy Graduation Ceremony. This ceremony highlights the regional impact of a lifetime patrol officer on their community and serves as a reminder of the respect and dedication that patrol work requires.</li>
</ol>`
,
  },
],


      rules: {
        required: (v) => !!v || "Required",
        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Enter a valid email",

        nominatedEmployeesRequired: (v) =>
          (Array.isArray(v) && v.length > 0) || "At least one nominated employee is required",

        maxNominatedEmployees: (v) =>
          (!Array.isArray(v) || v.length <= 10) || "Maximum 10 nominated employees",

        // Optional: keep any single entry from being absurdly long
        nominatedEmployeeItemLen: (v) =>
          (!Array.isArray(v) || v.every(x => (String(x || "").trim().length <= 120)))
          || "Each name must be 120 characters or less",
      },
    };
  },

  watch: {
    "nom.hasSupportingDocumentation"(val) {
      if (val !== "Yes") {
        this.nom.supportingDocumentationFiles = [];
        this.supportingFilesIncoming = [];

        if (this.$refs.supportingFiles) this.$refs.supportingFiles.reset();
      }
    },
  },

  computed: {
      selectedMedalObj() {
        return this.medals.find(m => m.name === this.nom.selectedMedal) || null;
      },
    admin() {
      return this.$store.state.user.roles.indexOf("pubcom-admin") > -1;
    },

    supportingFileRequiredMissing() {
      if (this.nom.hasSupportingDocumentation !== "Yes") return false;

      const f = this.nom.supportingDocumentationFiles;
      const count =
        Array.isArray(f) ? f.length :
        (f && typeof f.length === "number") ? f.length :
        (f ? 1 : 0);

      return count === 0;
    },
  },

  methods: {
  nomineeRules() {
  // Don’t show red on initial load
  if (!this.nomineeTouched && !this.submitAttempted) return [];

  return [
    this.rules.nominatedEmployeesRequired,
    this.rules.maxNominatedEmployees,
    // (optional if you want)
    // this.rules.nominatedEmployeeItemLen,
  ];
},
  filesRequiredRule() {
  if (this.nom.hasSupportingDocumentation !== "Yes") return true;

  const f = this.nom.supportingDocumentationFiles;

  const count =
    Array.isArray(f) ? f.length :
    (f && typeof f.length === "number") ? f.length :
    (f ? 1 : 0);

  return count > 0 || "At least one file is required if you selected Yes";
},

  onSupportingFilesChange(files) {
  const ALLOWED_EXTS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];

  const incoming = Array.isArray(files) ? files : (files ? [files] : []);
  if (!Array.isArray(this.nom.supportingDocumentationFiles)) {
    this.nom.supportingDocumentationFiles = [];
  }

  const rejected = [];

  incoming.forEach(f => {
    if (!f) return;

    // File type guard
    const ext = (f.name.split('.').pop() || '').toLowerCase();
    if (!ALLOWED_EXTS.includes(ext)) {
      rejected.push(f.name);
      return;
    }

    // "Same file" check: name + size + lastModified
    const exists = this.nom.supportingDocumentationFiles.some(x =>
      x &&
      x.name === f.name &&
      x.size === f.size &&
      x.lastModified === f.lastModified
    );

    if (!exists) this.nom.supportingDocumentationFiles.push(f);
  });

  if (rejected.length) {
    this.swall_it(
      'File Type Not Allowed',
      `The following file(s) could not be added: ${rejected.join(', ')}. Supported types: .pdf, .doc, .docx, .jpg, .jpeg, .png`,
      'warning',
      null,
      null
    );
  }

  // Clear the temp model so picking again doesn't replace anything
  this.supportingFilesIncoming = [];
},
  removeSupportingFile(index) {
  if (!Array.isArray(this.nom.supportingDocumentationFiles)) return;
  const next = [...this.nom.supportingDocumentationFiles];
  next.splice(index, 1);
  this.nom.supportingDocumentationFiles = next;

  // optional: if user removes all, also clear UI state
  if (next.length === 0 && this.$refs.supportingFiles) {
    this.$refs.supportingFiles.reset();
  }
},

prettyBytes(bytes) {
  if (bytes == null || isNaN(bytes)) return "";
  const thresh = 1024;
  if (bytes < thresh) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let u = -1;
  let b = bytes;
  do {
    b /= thresh;
    ++u;
  } while (b >= thresh && u < units.length - 1);
  return `${b.toFixed(1)} ${units[u]}`;
},

    close_medal_dialog() {
      // If you want to FORCE a choice, don’t allow closing when blank.
      this.medal_dialog = false;
    },

    select_medal(name) {
      this.nom.selectedMedal = name;
      this.medal_dialog = false;
    },

 

    go_admin() {
      this.$router.push("/admin");
    },

    save_awardnom() {
       this.submitAttempted = true;
      if (!this.$refs.medalForm.validate()) {
        this.swall_it(
          "Submit Status",
          "Please attend to the fields marked in red.",
          "warning",
          null,
          null
        );
        return;
      }

      const fd = new FormData();
      fd.append("selectedMedal", this.nom.selectedMedal || "");
  
  const nominatedEmployeeJoined = (Array.isArray(this.nom.nominatedEmployees) ? this.nom.nominatedEmployees : [])
  .map(x => String(x || "").trim())
  .filter(Boolean)
  .slice(0, 10)
  .join("; ");

fd.append("nominatedEmployee", nominatedEmployeeJoined);

      fd.append("eventCaseOrCallNumber", this.nom.eventCaseOrCallNumber || "");
      fd.append("hasSupportingDocumentation", this.nom.hasSupportingDocumentation || "");
      fd.append("nominationNarrative", this.nom.nominationNarrative || "");
      fd.append("submittedByEmail", this.nom.submittedByEmail || "");
      fd.append("email", this.nom.submittedByEmail || "");

      if (this.nom.hasSupportingDocumentation === "Yes" && this.nom.supportingDocumentationFiles?.length) {
        this.nom.supportingDocumentationFiles.forEach((file) => {
          fd.append("supportingDocumentationFiles", file);
        });
      }

      this.show_loader(true);

      this.$store
        .dispatch("uploadfile", fd)
        .then((data) => {
          const payload = data && data.data ? data.data : data;

          console.log("Upload payload:", payload);
          console.log("Upload correlationId:", payload && payload.correlationId);
          console.log("Email result:", payload && payload.emailResult);
          console.log("Email CID:", payload && payload.emailCid);

          this.show_loader(false);

          this.swall_it("Submit Status", "Your nomination has been submitted.", "success", null, null);

          this.$refs.medalForm.reset();
          this.$refs.medalForm.resetValidation();
          if (this.$refs.supportingFiles) this.$refs.supportingFiles.reset();

          this.nom = this.mno(this.nom_new);
        })
        .catch((err) => {
          this.show_loader(false);

          const msg =
            (err && err.response && err.response.data && (err.response.data.msg || err.response.data.message)) ||
            (err && err.message) ||
            (typeof err === "string" ? err : "Server error");

          const cid =
            err && err.response && err.response.data && (err.response.data.emailCid || err.response.data.correlationId);

          const finalMsg = cid ? `${msg} (CID: ${cid})` : msg;
          this.swall_it("Error", finalMsg, "error", null, null);
        });
    },

    init() {
      this.show_loader(false);
      this.nom = this.mno(this.nom_new);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>